import React, { useEffect, useState } from 'react'
import useStyles from './styles'
import { CssBaseline, Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button } from '@material-ui/core';
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';
import { commerce } from '../../../lib/commerce';
const steps = ['Shipping address', 'Payment details']

const Confirmation = () => {
  <div>
    Confirmation
  </div>
}



const Checkout = ({cart, order, onCaptureCheckout, error}) => {
  
  const [activeStep, setActiveStep] = useState(2);
  const [checkoutToken , setCheckoutToken] = useState(null);
  const [shippingData , setShippingData] = useState({});
  const classes = useStyles();
  
  useEffect(() =>{
    const generateToken =async() =>{
      try {
        const token =await commerce.checkout.generateToken(cart.id ,{type:'cart'})
        console.log(token);
        setCheckoutToken(token)
      } catch (error) {
        
      }
    }

    generateToken();
  }, []);

const nextStep =()=> setActiveStep((prevActiveStep)=>prevActiveStep+1);
const backStep =()=> setActiveStep((prevActiveStep)=>prevActiveStep-1);

  const next =(data) =>{
    setShippingData(data);
  }

  const Form = () => activeStep === 0 
  ? <AddressForm checkoutToken={checkoutToken} next={next} />
  : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} onCaptureCheckout={onCaptureCheckout}/>
  return (
    <>
      <div className={classes.toolbar} />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography variant='h4' align='center'>Checkout</Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? <Confirmation/> : checkoutToken && <Form />}
        </Paper>
      </main>
    </>
  )
}

export default Checkout
